// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"880bbbc1","977":"be0d791d"}[chunkId] + ".chunk.js";
};